@if (banner()) {
  <div class="banner">
    <p [innerHTML]="banner()?.content"></p>
    <a [href]="banner()?.link" target="_blank">
      <button pButton severity="secondary">
        <span pButtonLabel [innerText]="banner()?.cta"></span>
        <i class="pi" [ngClass]="banner()?.ctaIcon ?? 'pi-arrow-right'" pButtonIcon></i>
      </button>
    </a>
  </div>
}
